import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

export const AI_login = apiBase.createInstance({
    endpoint: "/login",
    method: "post",
    reducer: "loginReducer",
    reduxKey: "addLoginData",
    action: "ADD_LOGIN",
    onSuccess: (data) => {
        return data
    }
});

export const AI_resetPassword = apiBase.createInstance({
    endpoint: "/reset-password/{token}",
    method: "put",
    reducer: "loginReducer",
    reduxKey: "resetPassword",
    action: "RESET_PASSWORD",
    onSuccess: (data) => {
        return data
    }
});

export const AI_forgotPassword = apiBase.createInstance({
    endpoint: "/forgot-password",
    method: "post",
    reducer: "loginReducer",
    reduxKey: "forgotPassword",
    action: "FORGOT_PASSWORD",
    onSuccess: (data) => {
        return data
    },
    middleware : notificationMiddleWare,
});

export const AI_resetPasswordTokenCheck = apiBase.createInstance({
    endpoint: "/reset-password-token-check",
    method: "post",
    reducer: "loginReducer",
    reduxKey: "resetPasswordTokenCheck",
    action: "RESET_PASSWORD_TOKEN_CHECK",
    onSuccess: (data) => {
        return data
    }
});

export const AI_checkToken = apiBase.createInstance({
    endpoint: "/check-token",
    method: "post",
    reducer: "loginReducer",
    reduxKey: "checkToken",
    action: "CHECK_TOKEN",
    onSuccess: (data) => {
        return data
    }
});

export const AI_changePassword = apiBase.createInstance({
    endpoint: "/change-password",
    method: "post",
    reducer: "loginReducer",
    reduxKey: "changePassword",
    action: "CHANGE_PASSWORD",
    onSuccess: (data) => data,
    middleware : notificationMiddleWare
});